<template>
  <div class="etermin-step services row rows">
    <div v-for="item in services" :key="item.id"  @click="addService(item.id)"
      class="col-12 col-lg-6 col-xl">
      <div class="service d-flex flex-column align-items-center border-radius-main p-5 pointer position-relative h-100" :class="{ 'service-checked': isActiveService(item.id) }" v-on:click="trackServiceSelection">
        <span class="check-field bg-gray-m position-absolute rounded-lg p-1" :class="{ 'box-checked d-flex': isActiveService(item.id) }"><font-awesome-icon class="check-icon text-ss" icon="check"/></span>
        <span class="check-field-0 bg-white position-absolute rounded-lg p-2" :class="{ 'box-checked-0 d-none': isActiveService(item.id) }"></span>
        <div class="mb-4 img" :style="{'background-image':'url('+getServiceImage(item.id)+')'}"></div>
        <div class="text">
          <h3 class="service-title font-weight-600 mb-1 mt-0 text-center p" v-html="item.name"></h3>
        </div>
        <div class="description p d-none" v-if="item.description" v-html="item.description"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
const now = new Date(moment());

export default {
    name: 'service-step',
    props: {
        appointement: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            id: 0,
            trackingFired: false
        }
    },
    computed: {
        ...mapGetters('etermin', ['getServiceImage']),
        ...mapState({
            services: state => state.etermin.services,
            steps: state => state.etermin.steps
        }),
        ...mapState([
            'selectedStore'
        ]),
        reservation () { return this.$store.getters['etermin/getReservation'] }
    },
    methods: {
        formatDate : function(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-')
        },
        addService: function (sid) {
            if (this.appointement.services.indexOf(sid) !== -1) {
                var index = this.appointement.services.indexOf(sid)
                this.appointement.services.splice(index, 1)
            } else {
                this.appointement.services=[]
                this.appointement.services.push(sid)
            }
            if (this.appointement.services.length > 0) {
                this.$store.dispatch('etermin/validateStep', {index: this.id, status: 1})
                this.$store.dispatch('etermin/selectServices', {services: this.appointement.services})
                this.$emit('getTimeSlots', this.formatDate(now) ,1)
            } else {
                this.$store.dispatch('etermin/validateStep', {index: this.id, status: 0})
            }
        },
        isActiveService: function (sid) {
            if (this.appointement.services.indexOf(sid) !== -1) {
                return true
            } else {
                return false
            }
        },
        trackServiceSelection: function () {
          if (!this.trackingFired) {
              // Google Tag-Manager push 'appointment booking start' to dataLayer
              if (window.dataLayer) {
                  window.dataLayer.push({
                      event: `booking`,
                      event_type: `start`,
                      event_data: {}
                  })
              }
          }
          if (!this.trackingFired) this.trackingFired = true
        }

    },
    beforeMount () {
        this.appointement.time = null
        this.appointement.date = null
        this.$store.dispatch('etermin/validateStep', {index: (this.id+1), status: 0})
        this.appointement.calenderid = this.selectedStore.calenderid
    },
    async mounted () {
        await this.$store.dispatch('etermin/fetchServices', {
            store: this.selectedStore
        })
        /*this.$store.dispatch('etermin/postNotification', {
            calenderid: this.selectedStore.calenderid
        })*/
    }
}
</script>

<style lang="css">

</style>
